import { Controller } from '@hotwired/stimulus';
import { TabulatorFull as Tabulator } from 'tabulator-tables';

export default class extends Controller {
  static values = {
    options: Object,
    layout: {
      type: String,
      default: 'fitDataStretch',
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    paginationSize: {
      type: Number,
      default: 100,
    },
  };
  static targets = ['table'];

  connect() {
    let tableId = '#' + this.tableTarget.id;

    let defaultOptions = {
      layout: this.layoutValue,
      pagination: this.paginationValue,
      paginationSize: this.paginationSizeValue,
      // paginationSizeSelector:true
    };

    let mergedOpts = { ...defaultOptions, ...this.optionsValue };

    this.table = new Tabulator(tableId, mergedOpts);

    // Optionally, expose the table instance for global access, e.g., for debugging or direct manipulation
    // window.myTabulatorInstance = this.table;
  }
}
